import { FiFileText, FiImage, FiCode, FiMessageSquare, FiCpu } from 'react-icons/fi';
import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';

const FEATURES = [
  {
    icon: FiMessageSquare,
    title: 'Chat that works the way you do',
    description:
      'Fast, streaming conversations — start typing, get answers as they\'re generated, and stop generation at any time. Unlimited conversation history, organized in a simple sidebar. Export any conversation as PDF or JSON, or request a full email export. Light and dark themes.',
    badge: null,
  },
  {
    icon: FiFileText,
    title: 'Read & write',
    description:
      'Attach a document — PDF, Word, plain text, or Markdown — and ask Piua AI questions about it, get a summary, or request feedback, without ever pasting the raw content into a public AI tool.',
    badge: 'Advanced',
  },
  {
    icon: FiImage,
    title: 'Image generation',
    description:
      'Generate images directly from a text prompt, from inside the same chat interface you already use for text.',
    badge: 'Advanced',
  },
  {
    icon: FiCpu,
    title: 'Your own AI agents',
    description:
      "Set up dedicated agents that take your routine, repetitive work off your plate — running the same privacy screening as every chat — so you only step in for what actually needs a person.",
    badge: 'Advanced',
  },
  {
    icon: FiCode,
    title: 'API integration',
    description:
      "Programmatic access to Piua AI for Advanced-tier accounts, so you can bring Piua AI's privacy-first AI layer into your own tools and workflows.",
    badge: 'Advanced',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="scroll-mt-24 py-24">
      <div className="container-page flex flex-col items-center gap-14">
        <SectionHeading
          eyebrow="Core features"
          title="Everything you need to work faster, privately"
          description="A single, privacy-first place to work with AI — whether you're drafting emails solo or rolling out access to your whole team."
        />

        <div className="grid w-full grid-cols-1 gap-6 sm:grid-cols-2">
          {FEATURES.map((feature, index) => (
            <Reveal key={feature.title} delay={index * 0.08} className="card flex flex-col gap-4 p-8">
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-gradient-soft text-brand-600 dark:text-brand-300">
                  <feature.icon size={20} />
                </span>
                {feature.badge && (
                  <span className="rounded-full bg-surface px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-subtle dark:bg-midnight-600">
                    {feature.badge}
                  </span>
                )}
              </div>
              <h3 className="text-lg font-bold text-ink dark:text-white">{feature.title}</h3>
              <p className="text-sm leading-relaxed text-muted dark:text-subtle">{feature.description}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
